// src/components/pdf/TennisReportPDF.jsx
import React from 'react';
import { Document } from '@react-pdf/renderer';
import HeaderPage from './HeaderPage';
import GeneralStatsPage from './GeneralStatsPage';
import AdvancedStatsPage1 from './AdvancedStatsPage1';
import AdvancedStatsPage2 from './AdvancedStatsPage2';
import AdvancedStatsPage3 from './AdvancedStatsPage3';

/**
 * Document PDF complet du rapport Tennis
 */
const TennisReportPDF = ({ match, playerName, playerCode, statsJ1, statsJ2, advancedStats, comments }) => {
  return (
    <Document
      title={`TenStats_${playerName}_${new Date().toISOString().split('T')[0]}`}
      author="Ten Stats"
      subject="Rapport de match"
    >
      {/* Page 1 : En-tête et informations match */}
      <HeaderPage match={match} />

      {/* Pages 2-3 : Statistiques générales */}
      <GeneralStatsPage match={match} statsJ1={statsJ1} statsJ2={statsJ2} />

      {/* Pages 4-6 : Statistiques avancées */}
      <AdvancedStatsPage1 
        match={match} 
        playerName={playerName}
        playerCode={playerCode}
        advancedStats={advancedStats}
        comments={comments}
      />
      
      <AdvancedStatsPage2 
        match={match} 
        playerName={playerName}
        playerCode={playerCode}
        advancedStats={advancedStats}
        comments={comments}
      />
      
      <AdvancedStatsPage3 
        match={match} 
        playerName={playerName}
        playerCode={playerCode}
        advancedStats={advancedStats}
        comments={comments}
      />
    </Document>
  );
};

export default TennisReportPDF;